<template>
<div v-role="roles">
  <v-progress-linear  style="margin : 0 auto ; height:10px" indeterminate v-if="isLoading"></v-progress-linear>
  <v-data-table
    :headers="headers"
    :items="turmas"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-btn
          to="/painelClassTurma"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>

        <v-divider class="mx-8" inset vertical></v-divider>
            <span>Selecionado :</span>
            <v-select style="margin-top:30px;"
              :items="Listaranoslectivo"
              v-model="anolectivoSelected"
              item-value="descricao"
              item-text="novadescricao"
              @change="FiltraAnolectivo()"
              label="Selecione o Ano lectivo"
              return-object
            ></v-select>

        <div v-role="roles" class="flex-grow-1"></div>
          <v-btn  v-if="search"  @click="initializeturmasAll(search)" text icon color="green">
            <v-icon>cached</v-icon>
          </v-btn>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4" inset vertical></v-divider>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn class="mx-2" fab dark color="primary" v-on="on">
              <v-icon dark>add</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} -</span>
              <span v-if="idclasse === 1">10ª classe</span>
              <span v-if="idclasse === 2">11ª classe</span>
              <span v-if="idclasse === 3">12ª classe</span>
              <span v-if="idclasse === 4">13ª classe</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage || turmaExistente"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                      <span
 v-if="sala && flag_curso && editedItem.periodo.value && false"
                        ref="myid"
                      >
                        {{
                          flag_curso
                            .trim()
                            .toUpperCase()
                            .substring(0, 3)
                            .concat("-")
                            .concat("SALA " + sala.padStart(2, "0") + "-")
                            .concat(editedItem.periodo.value + "-" + anolectivoSelected)
                        }}
                      </span>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-combobox
                        v-model="editedItem.idCurso"

                        item-text="descricao"
                        @change="createdTurmaflag_description"
                        :items="cursos"
                        chips
                        label="Curso"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        :rules="notaRules"
                        v-model="sala"
                        label="Sala"
                        @change="concatTurmaAnolectivo(1)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                      <v-text-field
                        :rules="notaRules"
                        v-model="capacidade"
                        label="Capacidade"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="4">
                      <v-combobox
                        v-model="editedItem.periodo"
                        item-value="value"
                        item-text="descricao"
                        :items="periodos"
                        chips
                        @change="concatTurmaAnolectivo(1)"
                        label="Periodo"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="8" >
                      <v-text-field
                        v-model="editedItem.descricao"
                        :rules="[v => !!v || 'campo obrigatório.']"
                        :disabled='!disabledTurmaDescricao'
                        label="Descrição da Turma"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
               <v-row>
                   <v-col md="10"></v-col>
                   <v-col md="2">
                      <v-progress-circular v-if="progresso"
                    :size="50"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
                   </v-col>
                </v-row>
              <v-spacer></v-spacer>
             <v-btn
      class="ma-2"
      :loading="loading2"
      color="success"
      :disabled="
                  !(formValid && sala && flag_curso && editedItem.periodo.value && !turmaExistente)
                "
                @click="save"

    >
      Salvar
      <template v-slot:loader>
        <span>Loading...</span>
      </template>
    </v-btn>
              <v-btn color="red darken-1"  @click="close">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
       </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              fab dark color="teal"
              style="color:white"
              v-on="on"
            >
              <v-icon>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="ListagemEstudantes(item)"> <v-icon  class="mr-2" style="color:green">receipt</v-icon> <span> - Lista de Estudantes</span></v-list-item>
            <v-list-item v-if="isIlha" @click="cartaoEstudante(item)"> <v-icon  class="mr-2" style="color:#808080">print</v-icon> <span> - Cartões de Estudantes</span></v-list-item>
            <v-list-item v-if="isIlha" @click="boletimTurma(item)"> <v-icon  class="mr-2" style="color:#808080">insert_drive_file</v-icon><span> - Boletim de notas</span></v-list-item>
            <!-- <v-list-item @click="deleteItem(item)"> <v-icon small style="color:red"  class="mr-2">delete</v-icon> <span style="color:red;" > -Eliminar</span></v-list-item> -->
              <v-list-item @click="redificarCapacidade(item)"> <v-icon small style="color:blue"  class="mr-2">add</v-icon> <span style="color:black;" > Redifinir capacidade</span></v-list-item> 
              <v-list-item @click="showEditarDescricaoTurma(item)"> <v-icon small style="color:blue"  class="mr-2">add</v-icon> <span style="color:black;" > Editar descrição Turma</span></v-list-item> 
          </v-list>
        </v-menu>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>

  <template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogCapacidade"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title style="background-color:#006699;">
          <span class="text-h5" style="color:white;">Redifinir Capacidade Turma</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
                <span>Turma:</span><span style="font-weight:bold;">{{(objturma !== null)?objturma.turmadescricao:''}}</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
               <span>Capacidade:</span><span style="font-weight:bold;">{{(objturma !== null)?objturma.capacidade:''}}</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
                <span>Estudantes na turma:</span><span style="font-weight:bold;">{{(objturma !== null)?objturma.quantalunos:''}}</span>
              </v-col>
              <hr>
              
            </v-row>
            <hr>
            <v-row>
            <v-col
              cols="12"
                sm="6"
                md="6"
                style="margin-top:10px;"
             >
                   <v-text-field
                        outlined
                        :rules="notaRules"
                        v-model="capacidade"
                        label="Nova Capacidade"
                      ></v-text-field>
                </v-col>
            </v-row>
             
          </v-container>
         </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialogCapacidade = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="capacidade === '' || capacidade === null"
            @click="saveCapacidade()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<!-- ****************************************************************************************************** -->

<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogDescricao"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-overlay :value="overlay">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
          </v-overlay>
        <v-card-title style="background-color:#006699;">
          <span class="text-h5" style="color:white;">Editar Descrição Turma</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
                <span>Turma:</span><span style="font-weight:bold;">{{(objturma !== null)?objturma.turmadescricao:''}}</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
               <span>Capacidade:</span><span style="font-weight:bold;">{{(objturma !== null)?objturma.capacidade:''}}</span>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="12"
              >
                <span>Estudantes na turma:</span><span style="font-weight:bold;">{{(objturma !== null)?objturma.quantalunos:''}}</span>
              </v-col>
              <hr>
              
            </v-row>
            <hr>
            <v-row>
            <v-col md="2"></v-col>
            <v-col
              cols="12"
                sm="6"
                md="7"
                style="margin-top:10px;"
             >
                   <v-text-field
                        outlined
                        :rules="ruleTextRequired"
                        v-model="novaDescricaoTurma"
                        label="Nova descrição da Turma"
                      ></v-text-field>
                </v-col>
            </v-row>
             
          </v-container>
         </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="dialogDescricao = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="novaDescricaoTurma === '' || novaDescricaoTurma === null"
            @click="saveEditarDescricao()"
          >
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>


<!-- ********************************************************************************************************************** -->

</div>
</template>
<script>
import axios from '../../../../../plugins/axios'
import QRCode from 'qrcode'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    loading2: false,
    overlay: false,
    imagecard: ls.get('cardEstudante'),
    insignia: ls.get('insignia'),
    logotipo: ls.get('logotipo'),
    url: ls.get('urlReport'),
    generateQR: null,
    instituicao: ls.get('i_id'),
    turmasClasseAnolectivo: [],
    iskilamba: (!!window.location.host.includes('eftsk')),
    roles: 'func',
    text: '',
    capacidade: null,
    dialogCapacidade: false,
    dialogDescricao: false,
    novaDescricaoTurma:'',
    flag_curso: '',
    formValid: true,
    objturma: null,
    isLoading: false,
    Listaranoslectivo: [],
    alunosTurma: [],
    flag_periodo: '',
    flag_sala: '',
    flag_class: '',
    progresso: false,
    anolectivoSelected: null,
    sala: '',
    search: '',
    cursos: [],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
       
    ],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    periodos: [
      { descricao: 'Manhã', value: 'M', id: 1 },
      { descricao: 'Tarde', value: 'T', id: 2 }
    ],
    turmas: [],
    dialog: false,
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Capacidade', value: 'capacidade' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idCurso: {
        idCurso: '0',
        descricao: ''
      },
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    defaultItem: {
      idCurso: {
        idCurso: '0',
        descricao: ''
      },
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    }
  }),

  computed: {

    isBendizer () {
      return window.location.host.includes('bendizer.net') || window.location.host.includes('localhost') || window.location.host.includes('192.168.18.15')
    },
    isIlha () {
      return (ls.get('i_id') === 24 ? 1 : 0)
    },
    formTitle () {
      return this.editedIndex === -1 ? 'Nova Turma' : 'Editar Turma'
    },

    idclasse () {
      return this.$store.state.idclasse
    },
    classeTur () {
      return this.$store.state.classeTur
    },
    disabledTurmaDescricao () {
      return (!!(this.editedItem.periodo && this.editedItem.idCurso && this.sala))
    },

    turmaExistente () {
      let pkTurma = this.$store.state.anolectivoSelecionado.substr(-2)
        .concat(this.editedItem.idCurso.idCurso + '' + this.editedItem.periodo.id)
        .concat(this.sala.padStart(2, '0') + '' + (this.instituicao.toString()).padStart(3, '0'))
      if (this.turmasClasseAnolectivo.filter(t => t.pkTurma === parseInt(pkTurma)).length === 0) {
        return false
      } else {
        this.$store.dispatch('textMessage', {
          msg: 'A turma já existe',
          classMessage: 'msgError',
          timeout: 3000
        })
        return true
      }
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // check if classe has been selected otherwise send back to painel to select
    if (!this.$store.state.idclasse) { this.$router.push('/painelClassTurma') }
    this.initializeCursos()
    this.initializeturmasAll()
    this.initializeAnosLectivo()
    this.initializeturmasAll_classeAnolectivo()
    this.anolectivoSelected = this.$store.state.anolectivoSelecionado
  },

  methods: {
    /** Turmas criadas pela instituicao e adicionadas ao sistema */
    concatTurmaAnolectivo (valor) {
      if (valor === 1) {
        this.editedItem.descricao = this.flag_curso
          .trim()
          .toUpperCase()
          .substring(0, 3)
          .concat('-')
          .concat('SALA ' + this.sala.padStart(2, '0') + '-')
          .concat(this.editedItem.periodo.value + '-' + this.$store.state.novadescricaoSelecionado)
      }
    },

    redificarCapacidade (item) {
      this.objturma = item
      this.dialogCapacidade = true
    },


    showEditarDescricaoTurma (item){
      this.dialogDescricao = true
      this.objturma = item
      this.novaDescricaoTurma = item.turmadescricao
    },

    createdTurmaflag_description () {
      // flag_periodo:'',
      // flag_sala:

      this.flag_curso = this.editedItem.idCurso.descricao
      this.concatTurmaAnolectivo(1)
      //  this.flag_sala = this.sala
    },
    async initializeCursos () {
      try {
        //
        this.cursos = await axios.get('/cursoFindAll').then(res => res.data)
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeturmasAll (search) {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
        this.isLoading = false
      }
    },
    async initializeturmasAll_classeAnolectivo (search) {
      try {
        this.isLoading = true
        this.turmasClasseAnolectivo = await axios
          .get('/turmaFindAll-Anolectivo-classe/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
        this.isLoading = false
      }
    },

    async saveEditarDescricao (){
        try {
          this.overlay = true
          let params = {
              turma: this.objturma,
              novaDescricao: this.novaDescricaoTurma
          }
          let result = await axios
          .post('/editarDescricaoTurma',params).then(res => res.data)
          if(result.affectedRows >=1 ){
             this.initializeturmasAll()
             Swal.fire('Informação','Descrição da turma alterada com sucesso','success')
             this.dialogDescricao = false
          }else{
               Swal.fire('Informação','Descrição da turma já existente','warning')
          }
        } catch (error) {
          Swal.fire('Informação','Ocorreu um erro ao tentar efectuar a operação','error')
          this.dialogDescricao = false
        }finally{
          this.overlay = false
        }

    },

    editItem (item) {
      this.editedIndex = this.turmas.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      confirm('Are you sure you want to delete this item?') &&

        this.EliminaTurma(item)
    },

    async initializeAnosLectivo () {
      try {
        this.isLoading = true
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
        this.isLoading = false
      }
    },

    async saveCapacidade () {
      try {
        let params = { turma: this.objturma, capacidade: this.capacidade }
        let result = await axios.post('/saveCapacidade', params).then(res => res.data)
        if (result.affectedRows >= 1) {
          this.dialogCapacidade = false
          this.initializeturmasAll()
        }
      } catch (error) {

      }
    },

    async EliminaTurma (item) {
      try {
        //
        this.alunosTurma = await axios.get('/turmaFindCountPk/' + item.pkTurma).then(res => res.data)
        if (!this.alunosTurma.length) {
          this.Eliminar(item)
          const index = this.turmas.indexOf(item)
          this.turmas.splice(index, 1)
        } else {
          this.text = 'Está turma não pode ser eliminada'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 2000
          })
        }
      } catch (error) {
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async Eliminar (item) {
      try {
        this.msg = await axios
          .get('/EliminarTurma/' + item.pkTurma)
          .then(res => res.data)

        this.text = this.msg
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgSucess',
          timeout: 4000
        })
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    ListagemEstudantes (item) {
      this.$store.state.objturma = item
      ls.set('backTo', 'turmacrud24')
      this.$router.push('ListaAlunos24')
    },

    async FiltraAnolectivo () {
      this.$store.state.novadescricaoSelecionado = this.anolectivoSelected.novadescricao
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected.descricao
      this.initializeturmasAll()
    },

    async save () {
      let turma = this.flag_curso.trim()
        .toUpperCase()
        .substring(0, 3)
        .concat('-')
        .concat('SALA ' + this.sala.padStart(2, '0') + '-')
        .concat(this.editedItem.periodo.value + '-' + this.$store.state.novadescricaoSelecionado)
      this.progresso = true
      try {
        var params = {
          idCurso: this.editedItem.idCurso.idCurso,
          idAno_Academico: this.idclasse,
          descricao: (this.isBendizer) ? this.editedItem.descricao : turma,
          autor: ls.get('nomeUsuario'),
          periodo: this.editedItem.periodo.descricao,
          sala: this.sala,
          capacidade: this.capacidade,
          anolectivo: this.$store.state.anolectivoSelecionado
        }
      } catch (error) {

      }

      try {
        let corMensagem = 'msgError'
        let msg = await axios
          .post('/turmaInsertOne', params)
          .then(res => res.data)
        // this.text = msg[1].insertId
        // verificação da mensagem  de erro
        if (msg === 'Turma ja existente') {
          this.text = 'Turma ja existente'
          this.$store.dispatch('textMessage', {
            msg: this.text,
            classMessage: 'msgError',
            timeout: 8000
          })
        } else
        if (msg.length) {
          let erro = msg[0]
          corMensagem = 'Ocorreu um erro ao tentar efectuar a operação.\n' + erro[0].Message
          this.text = ''
        } else {
          this.text = 'Operação efectuada com sucesso.'
          corMensagem = 'msgSucess'

          // Inserção dos dados do turma na coleção
          let d = new Date()
          d = new Date(d.getTime() - 3000000)
          // eslint-disable-next-line camelcase
          let date_format_str = d.getFullYear().toString() + '-' + ((d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1).toString() : '0' + (d.getMonth() + 1).toString()) + '-' + (d.getDate().toString().length === 2 ? d.getDate().toString() : '0' + d.getDate().toString()) + ' ' + (d.getHours().toString().length === 2 ? d.getHours().toString() : '0' + d.getHours().toString()) + ':' + ((parseInt(d.getMinutes() / 5) * 5).toString().length === 2 ? (parseInt(d.getMinutes() / 5) * 5).toString() : '0' + (parseInt(d.getMinutes() / 5) * 5).toString()) + ':00'
          let v = {
            turmadescricao: (this.isBendizer) ? this.editedItem.descricao : turma,
            periodo: this.editedItem.periodo.descricao,
            curso: this.editedItem.idCurso.descricao,
            data_2: date_format_str,
            pkTurma: parseInt(this.$store.state.anolectivoSelecionado.substr(-2)
              .concat(this.editedItem.idCurso.idCurso + '' + this.editedItem.periodo.id)
              .concat(this.sala.padStart(2, '0') + '' + (this.instituicao.toString()).padStart(3, '0')))
          }
          this.progresso = false
          this.turmas.unshift(v)
          this.turmasClasseAnolectivo.unshift(v)
          this.$refs.form.resetValidation()
          //= ==========================================
          this.dialog = false
        }
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: corMensagem,
          timeout: 2000
        })
      } catch (error) {
        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      }

      this.progresso = false
    },
    // METHODO FOR VALIDATION
    validate () {
      this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    //* ***************************************************************************************** */
    boletimTurma (item) {
      this.$store.state.objturma = item
      ls.set('backTo', 'turmacrud24')
      this.$router.push('Boletim-Turma')
    },

    async cartaoEstudante (item) {
      this.$store.state.objturma = item
      this.isLoading = true
      try {
        this.listEstudantfromPauta = await axios.get('/ListaEstudantes/' + this.$store.state.objturma.pkTurma).then(res => res.data)
        if (this.listEstudantfromPauta.length > 0) {
          this.comporCard()
          // for (let index = 0; index < this.listEstudantfromPauta.length; index++) {
          //   const element = this.listEstudantfromPauta[index]
          //   this.listEstudantfromPauta[index].certificado = await this.generateQr(element)
          //   if (index === (this.listEstudantfromPauta.length - 1)) this.comporCard()
          // }
        }
      } catch (error) {
        this.isLoading = false
        this.$store.dispatch('textMessage', {
          msg: error,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async comporCard () {
      let font = {
        titulo1: '12px',
        titulo2: '13px'
      }
      this.isLoading = true
      let card = ``
      this.listEstudantfromPauta.forEach(element => {
        let foto = (ls.get('urlReport') + 'readphoto/' + element.foto)
        let nome = (element.nome.substring(0, element.nome.indexOf(' ')) + ' ' + element.nome.substring(element.nome.lastIndexOf(' '), element.nome.length)).toUpperCase()
        card += `
        <div class="row">
        <div class="column">
      <div class="card" style="background-image: url(` + this.imagecard + `);background-size: cover;background-repeat: no-repeat;height: 100%;background-position: center;">    
      <center><img src='` + this.logotipo + `' alt="" style="width:50px;display: block;margin-left: auto;margin-right: auto;"></center>
      
      <table style="width:100%">
    
        <tr> <td style="width:100%;text-align:center;font-weight:bold;font-size:12px;line-height: 9px;" >INSTITUTO TÉCNICO PRRIVADO DE SAÚDE</td></tr>
        <tr><td style="width:100%;text-align:center;font-weight:bold;font-size:12px;line-height: 9px;" >` + ls.get('instituicaodescricao').toUpperCase() + `</td></tr>
    <tr><td style="text-align: right;font-size: ` + font.titulo1 + `;">CARTÃO DO ALUNO</td>  </tr>
    </table>
    <table style="width:100%">      
      <tr>        
        <td style="width:80%;text-align: center;">     
          <p style="text-align: justify;font-size: ` + font.titulo1 + `;">Nome</p>         
          <p style="text-align: justify;font-size: ` + font.titulo2 + `;font-weight: bold;text-align:justify;color: #f1f1f1;"> ` + nome + `</p>         
          <p style="text-align: justify;font-size: ` + font.titulo1 + `;">Curso</p>
          <p style="text-align: justify;font-size: ` + font.titulo2 + `;font-weight: bold;text-align:justify;color: #f1f1f1;">` + element.curso.toUpperCase() + `</p>
          <p style="text-align: justify;font-size: ` + font.titulo1 + `;">Matricula</p>
          <p style="text-align: justify;font-size: ` + font.titulo2 + `;font-weight: bold;text-align:justify;color: #f1f1f1;">` + element.idMAtricula + `</p></td>   
          <td style="width:20%;text-align:left"> 
            <img src="` + foto + `" alt="" style="width:100px;height:80px;"> 
             </td> 
      </tr>
      <tr><td colspan="2" style="font-size:8px;color:#ffffff;font-weight:bold;text-align:left;padding-top:10px;">
        (t) 923 310 818 WhatsApp (e)ilhadaverdade2006@gmail.com
        <p>(m) Município do Cazenga, Distrito Urbano 11 de Novembro, Rua da Volvo (Kicolo) </p>
        </td></tr>
      </table>
        </div>
      </div>
    </div><br>
      <div class="row">
        <div class="column">
      <div class="card">
        <table style="width:100%;">
          <tr> <td style="text-align:right;"> <img  src="` + ls.get('urlReport') + `barCode/` + element.idMatricula + `" alt="" style="width:100px;height:60px;border-radius: 0% !important;"/></td> </tr> 
          <tr><td class="tamvalidCard">Este cartão é válido para um ciclo lectivo</td><tr>
           </table>
      </div>
      </div>
    </div>`
      })
      this.html = `
     <style>
     .tamvalidCard {
        font-size: 11px;
        font-family: sans-serif;
        text-align:center;
      }
table, th, td {
  border: 0px solid black;
  line-height: 2px;  
  padding-top:13px;
}
* {
  box-sizing: border-box;
}

body {
  font-family: sans-serif;
}

/* Float four columns side by side */
.column {
  float: left;
  width: 100%;
  padding: 0 10px;
}

/* Remove extra left and right margins, due to padding */
.row {margin: 0 -5px;}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}

/* Responsive columns */
@media screen and (max-width: 600px) {
  .column {
    width: 100%;
    display: block;
    margin-bottom: 20px;
  }
}

/* Style the counter cards */
.card {
  box-shadow: 0 4px 8px 0  #ffffff;
  text-align: center;
  background-color:  #ffffff;
  height: 280px;
}
</style>
      <body>
      ` + card + `
      </body>`
      let option = { 'format': 'A7',
        'orientation': 'landscape',
        'header': {
          'height': '2mm' },
        'footer': {
          'height': '2mm'
        }
      }
      this.gerarpdf(option)
    },
    async gerarpdf (option) {
      try {
        let result = await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('nomeUsuario'),
            option: option
          }
        }).then((res) => res.data)
        if (result.length === 56) { this.frame() }
        this.frame()
      } catch (error) {
        this.isLoading = false
      }
    },
    frame () {
      let readfile = ls.get('urlReport') + 'readfile/' + ls.get('nomeUsuario') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + readfile + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
      this.isLoading = false
    }
    //* ********************************************************************************************* */
    // END METHOD FOR VAL
  }
}
</script>
